import React, { createContext, useState } from 'react'
import { Layout } from './components/Layout'
import { ReviewsProvider } from 'components/Reviews'
import { ProductData } from 'lib/types'

interface Props {
  product: ProductData
}

export const ProductScene = ({ product }: Props) => {
  const sku = product.sku
  const fromProductSelector = window.location.href.split('#')?.[1] === 'fromProductSelector' ?? false
  const forceOneTimePurchase = window.location.href.split('#')?.[1] === 'oneTime' ?? false

  return (
    <ProductProvider>
      <ReviewsProvider>
        <Layout
          key={sku}
          fromProductSelector={fromProductSelector}
          forceOneTimePurchase={forceOneTimePurchase}
          product={product}
        />
      </ReviewsProvider>
    </ProductProvider>
  )
}

interface ProductContextInterface {
  descriptionTabOpen: number
  setDescriptionTabOpen: (tabIndex: number) => void
}

export const ProductContext = createContext<ProductContextInterface>({
  descriptionTabOpen: 0,
  setDescriptionTabOpen: (tabIndex) => undefined
})

export const ProductProvider: React.FC = ({ children }) => {
  const [descriptionTabOpen, setDescriptionTabOpen] = useState(0)

  return (
    <ProductContext.Provider
      value={{
        descriptionTabOpen,
        setDescriptionTabOpen
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}

export const useProductContext = () => {
  const context = React.useContext(ProductContext)
  if (context === undefined) {
    throw new Error('useProduct must be used within a ProductProvider')
  }
  return context
}
